module.exports = __webpack_public_path__ + "80f6811f6c30735dab68a01372d8b78f.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-SemiboldItalic.woff2
// module id = 1013
// module chunks = 0